export default () => {
  return (
    <svg
      width="27"
      height="28"
      viewBox="0 0 27 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="13.3467"
        cy="13.3467"
        r="13.3467"
        transform="matrix(-1 0 0 1 26.9805 0.652344)"
        fill="#006299"
      />
      <line
        x1="1"
        y1="-1"
        x2="9.28412"
        y2="-1"
        transform="matrix(-0.707107 0.707107 0.707107 0.707107 19.9355 8.08301)"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <line
        x1="18.5213"
        y1="19.915"
        x2="12.6636"
        y2="14.0573"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <line
        x1="1"
        y1="-1"
        x2="9.28412"
        y2="-1"
        transform="matrix(-0.707107 0.707107 0.707107 0.707107 14.6035 8.08301)"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <line
        x1="13.1893"
        y1="19.915"
        x2="7.33154"
        y2="14.0573"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};
